import React, { forwardRef } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import { HelperTooltipBootstrap } from 'components/CustomTooltips';

// material-ui components
import { makeStyles, createStyles } from '@mui/styles';
import { Button } from '@mui/material';

import styles from "assets/jss/components/buttonStyle.js";

const useStyles = makeStyles(createStyles(styles));

const RegularButton = forwardRef((props, ref) => {
  const classes = useStyles();
  const {
    color,
    round,
    children,
    fullWidth,
    disabled,
    simple,
    size,
    block,
    link,
    justIcon,
    className,
    muiClasses,
    title,
    placement,
    arrow,
    ...rest
  } = props;
  const btnClasses = classNames({
    [classes.button]: true,
    [classes[size]]: size,
    [classes[color]]: color,
    [classes.round]: round,
    [classes.fullWidth]: fullWidth,
    [classes.disabled]: disabled,
    [classes.simple]: simple,
    [classes.block]: block,
    [classes.link]: link,
    [classes.justIcon]: justIcon,
    [className]: className
  });

  return title
    ? <HelperTooltipBootstrap title={title} placement={placement} arrow={arrow}>
        <Button {...rest} ref={ref} classes={muiClasses} className={btnClasses}>
          {children}
        </Button>
      </HelperTooltipBootstrap>
    : <Button {...rest} ref={ref} classes={muiClasses} className={btnClasses}>
        {children}
      </Button>
});

RegularButton.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
    "white",
    "twitter",
    "facebook",
    "google",
    "linkedin",
    "pinterest",
    "youtube",
    "tumblr",
    "github",
    "behance",
    "dribbble",
    "reddit",
    "transparent"
  ]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  simple: PropTypes.bool,
  round: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  link: PropTypes.bool,
  justIcon: PropTypes.bool,
  className: PropTypes.string,
  muiClasses: PropTypes.object,
  children: PropTypes.node
};

export default RegularButton;
